import { getSelectedOffer } from '@product-details/store/selectors/selected.selector';
import { getDeliveryAddress } from '@view-offers/store/selectors/offers.selector';
import { getOfferReference } from '@view-offers/store/selectors/offer.reference.selector';
import { DeliveryDatesState } from './../reducers/replacement.delivery.dates.reducer';
import { PRODUCT_DETAILS_FEATURE } from './../reducers/index';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromProductDetails from '@product-details/store/reducers';
import { Address, ReplacementOffer } from '@dgx-pr-spa/shared/util';

export const getProductDetailsState =
  createFeatureSelector<fromProductDetails.ProductDetailsState>(
    PRODUCT_DETAILS_FEATURE
  );

export const getDeliveryDatesState = createSelector(
  getProductDetailsState,
  (state) => state?.deliveryDates
);

export const getDeliveryDates = createSelector(
  getDeliveryDatesState,
  (deliveryDates: DeliveryDatesState) => {
    return deliveryDates?.data;
  }
);

export const getDeliveryDatesLoading = createSelector(
  getDeliveryDatesState,
  (deliveryDates: DeliveryDatesState) => deliveryDates?.loading
);

export const getDeliveryDatesLoaded = createSelector(
  getDeliveryDatesState,
  (deliveryDates: DeliveryDatesState) => deliveryDates?.loaded
);

export const getDeliveryDatesError = createSelector(
  getDeliveryDatesState,
  (deliveryDates: DeliveryDatesState) => !!deliveryDates?.error
);

export const getDeliveryDatesRequestArgs = createSelector(
  [getOfferReference, getDeliveryAddress, getSelectedOffer],
  (reference, delivery, selected) => {
    const offer_reference = reference;
    const post_code =
      (delivery as Address)?.postal_code ?? (delivery as Address)?.PostalCode;
    const supplier_id = (selected as ReplacementOffer)?.supplier_id;
    const cat_num = (selected as ReplacementOffer)?.cat_num;

    return {
      offer_reference,
      post_code,
      supplier_id,
      cat_num,
      service_cat_numbers: null,
    };
  }
);
